console.log('hey1');
class ProductSubSelects extends HTMLElement {
    constructor() {
        super();
        this.addEventListener('change', this.onVariantChange);
    }

    onVariantChange() {
        console.log('hey it changed');
        document.querySelector('#onetime-selector').checked = false;
        this.updateOptions();
        //this.updateMasterId();
        //this.toggleAddButton(true, '', false);
        //this.updatePickupAvailability();

        if (!this.currentVariant) {
            //this.toggleAddButton(true, '', true);
            //this.setUnavailable();
        } else {
            //this.updateMedia();
            //this.updateURL();
            //this.updateVariantInput();
            //this.renderProductInfo();
        }
    }

    updateOptions() {
        this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
    }

}

class KiteSubRadios extends ProductSubSelects {
    constructor() {
        super();
    }

    updateOptions() {
        const fieldsets = Array.from(this.querySelectorAll('fieldset'));
        this.options = fieldsets.map((fieldset) => {
            return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
        });
    }
}

customElements.define('kte-sub-radios', KiteSubRadios);